export default "__VITE_ASSET__CLH9KBja__"